if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// === Size deselection system ===
// Uses body classes like Todd Derman's approach for reliable state tracking.
// Unchecks size visually, uses L as silent fallback for variant resolution,
// periodic enforcement catches all re-renders.
document.addEventListener('DOMContentLoaded', function() {
  // Detect if product has a Size option
  var hasSizeOption = false;
  var fallbackSizeValueId = null;
  document.querySelectorAll('variant-selects fieldset').forEach(function(fs) {
    var legend = fs.querySelector('legend');
    if (legend && legend.textContent.trim().startsWith('Size')) {
      hasSizeOption = true;
      var lRadio = Array.from(fs.querySelectorAll('input[type="radio"]')).find(function(r) {
        return r.value === 'L';
      });
      if (lRadio) fallbackSizeValueId = lRadio.dataset.optionValueId;
    }
  });
  if (!hasSizeOption) return;

  document.body.classList.add('size-required');

  // --- Helper: find size fieldset (always re-queries) ---
  function getSizeFieldset() {
    var fieldsets = document.querySelectorAll('variant-selects fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (legend && legend.textContent.trim().startsWith('Size')) return fieldsets[i];
    }
    return null;
  }

  // --- Uncheck all size radios and clear label ---
  function uncheckSize() {
    if (document.body.classList.contains('size-user-selected')) return;
    var fs = getSizeFieldset();
    if (!fs) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function(r) { r.checked = false; });
    var label = fs.querySelector('[data-selected-value]');
    if (label) label.textContent = '';
  }

  // Immediately uncheck
  uncheckSize();

  // --- Periodic enforcement (catches all AJAX re-renders) ---
  var enforceInterval = setInterval(function() {
    if (document.body.classList.contains('size-user-selected')) {
      clearInterval(enforceInterval);
      return;
    }
    uncheckSize();
  }, 100);

  // --- User explicitly selects a size (delegated on document, survives DOM replacement) ---
  document.addEventListener('change', function(e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('input[type="radio"]')) return;
    var fieldset = radio.closest('fieldset');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    if (legend && legend.textContent.trim().startsWith('Size')) {
      document.body.classList.add('size-user-selected');
      clearInterval(enforceInterval);
    }
  });

  // --- Patch selectedOptionValues to include L fallback when no size checked ---
  document.querySelectorAll('variant-selects').forEach(function(picker) {
    var origGetter = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(picker), 'selectedOptionValues'
    );
    if (origGetter && fallbackSizeValueId) {
      Object.defineProperty(picker, 'selectedOptionValues', {
        get: function() {
          var values = origGetter.get.call(this);
          var fs = getSizeFieldset();
          if (fs && !fs.querySelector('input:checked') && fallbackSizeValueId) {
            values.push(fallbackSizeValueId);
          }
          return values;
        }
      });
    }
  });

  // --- Block Add to Cart if no size selected (capture phase) ---
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('button[name="add"], .product-form__submit');
    if (btn && document.body.classList.contains('size-required') &&
        !document.body.classList.contains('size-user-selected')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Show error
      var pf = btn.closest('product-form');
      if (pf) {
        var wrapper = pf.querySelector('.product-form__error-message-wrapper');
        var msg = pf.querySelector('.product-form__error-message');
        if (wrapper && msg) {
          msg.textContent = 'Please select a size';
          wrapper.removeAttribute('hidden');
        }
      }

      // Shake the size pills
      var fs = getSizeFieldset();
      if (fs) {
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        fs.classList.add('size-not-selected');
        setTimeout(function() { fs.classList.remove('size-not-selected'); }, 2000);
      }
    }
  }, true);

  // --- Auto-activate if URL has variant param (direct link) ---
  if (new URLSearchParams(window.location.search).has('variant')) {
    document.body.classList.add('size-user-selected');
    clearInterval(enforceInterval);
  }
});
